import React from "react";
import Image from "next/image";
import Link from "next/link";
import Head from 'next/head';
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Hidden from "@mui/material/Hidden";
import Drawer from "@mui/material/Drawer";
// @mui/icons-material
import Menu from "@mui/icons-material/Menu";
import Close from "@mui/icons-material/Close";
// core components
import styles from "./Header.module.scss";

export default function Header(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;

    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(styles[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(styles[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(styles[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(styles[changeColorOnScroll.color]);
    }
  };
  

  const { color, links, brand, fixed, absolute, title, image, url, type, description, robots } = props;
  const appBarClasses = classNames({
    [styles.appBar]: true,
    [styles[color]]: color,
    [styles.absolute]: absolute,
    [styles.fixed]: fixed,
  });
  
  return (
    <div>
    <AppBar className={appBarClasses}>
      <Toolbar className={styles.container}>
        <Button className={styles.title}>
          <Link href="/">
              {/* <Image
              layout = "responsive"
              width = {170}
              height ={23}
              src = {brand}
              />
               */}
              <img 
                src={brand}
                style={{ height: 24, width: "auto" }}
                alt="Tribalism"
              />


          </Link>
        </Button>
        <Hidden mdDown implementation="css" className={styles.hidden}>
          <div className={styles.collapse}>{links}</div>
        </Hidden>
        <Hidden mdUp>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            size="large">
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: styles.drawerPaper,
          }}
          onClose={handleDrawerToggle}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            className={styles.closeButtonDrawer}
            size="large">
            <Close />
          </IconButton>
          <div className={styles.appResponsive}>{links}</div>
        </Drawer>
      </Hidden>
    </AppBar>
        <Head>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta property="og:image" content={image} />
          <meta property="og:url" content={url} />
          <meta property="og:locale" content="en_AU" />
          <meta property="og:type" content={type} />
          <meta property="og:description" content={description} />
          <meta name="description" content={description} />
          <meta name="robots" content={robots} />

        </Head>
  </div>
  );
}

Header.defaultProp = {
  color: "white",
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark",
  ]),
  links: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark",
    ]).isRequired,
  }),
};
